// extracted by mini-css-extract-plugin
module.exports = {"b172izsv":"b172izsv"};